// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralState as CollateralStateV2 } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/State/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

export const useCollateralStateV2: () => UseQueryResult<
  TemplateContract<CollateralStateV2>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useQueryWithOffset({
    queryKey: ['queryCollateralStateV2', operator],
    queryFn: async (_, offset) => {
      return ledgerApi.queryCollateralStateV2(offset, operator);
    },
  });
};
